import { ReactComponent as CheckStatusIcon } from '../img/iconCheck.svg';
import { ReactComponent as InfoStatusIcon } from '../img/iconInfo.svg';
import { FC } from 'react';
import styles from './StatusInfo.module.scss';

interface StatusInfoProps {
  importCount: number;
  uploadCount: number;
  isPreview?: boolean;
}

export const StatusInfo: FC<StatusInfoProps> = ({
  importCount,
  uploadCount,
  isPreview = false,
}) => {
  const isAllImported = importCount === uploadCount;

  return (
    <div className={styles.statusInfo}>
      {isAllImported ? <CheckStatusIcon /> : <InfoStatusIcon />}
      <span>
        {isPreview ? 'Будет загружено' : 'Загружено'} {importCount} из {uploadCount}{' '}
        сотрудников
      </span>
    </div>
  );
};
